// pos_local domain event-lərinə abunə olub verilmiş callback-i çağırır.
//
// Masa grid-i (`pages/Masalar.tsx`) artıq `useTableRealtimeWithFallback` ilə
// real-time alır (echo wrapper `.table.status-changed` yayır). Amma masanın
// SİFARİŞ MƏZMUNU (məhsul əlavə/sil/miqdar) heç yerdə dinlənmirdi — ekran yalnız
// mount olanda çəkilirdi, ona görə başqa cihazdan (yaxud QR-dan) gələn dəyişikliyi
// görmək üçün səhifəni yeniləmək lazım gəlirdi.
//
// Bu hook həmin boşluğu doldurur: pos_local WS-dən `orders.*` / `tables.*`
// event-i gələndə `onChange` çağırılır (burst-lar debounce ilə birləşir), komponent
// də öz mövcud fetch funksiyasını yenidən işlədir — yəni data shape-i HTTP yolu ilə
// eyni qalır, təkrar məntiq yoxdur.
//
// Cloud rejimində (POS_ENABLED=false) hook no-op-dur — orada Reverb kanalları işləyir.

import { useEffect, useRef } from 'react';
import { POS_ENABLED } from '../api/pos/config';
import { getPosWs } from '../api/pos/posWs';

/** Burst-ları (bir kliklə gələn bir neçə event) tək refetch-ə birləşdir. */
const DEBOUNCE_MS = 200;

/** Sifariş məzmununa təsir edən event prefiksləri. */
function affectsOrders(type: string): boolean {
  return type.startsWith('orders.') || type.startsWith('tables.');
}

/**
 * @param onChange  event gələndə çağırılır (adətən mövcud fetch funksiyası)
 * @param enabled   şərti söndürmək üçün (məs. modal bağlıdırsa)
 */
export function usePosOrderRealtime(onChange: () => void, enabled = true): void {
  // Callback-i ref-də saxla ki, hər render-də yenidən abunə olmayaq.
  const cbRef = useRef(onChange);
  cbRef.current = onChange;

  useEffect(() => {
    if (!POS_ENABLED || !enabled) return;

    const ws = getPosWs();
    // ref-counted — catalogNotify onsuz da açıq saxlayır, amma müstəqil işləsin deyə
    // burada da acquire edirik (idempotent).
    const release = ws.acquire();

    let timer: ReturnType<typeof setTimeout> | null = null;
    const off = ws.onEvent((e) => {
      if (!affectsOrders(e.type)) return;
      if (timer) return; // burst birləşdirmə
      timer = setTimeout(() => {
        timer = null;
        cbRef.current();
      }, DEBOUNCE_MS);
    });

    return () => {
      off();
      release();
      if (timer) clearTimeout(timer);
    };
  }, [enabled]);
}
